import React, { Component } from "react";

import Constants from "../../../utils/constants";

import dayjs from "dayjs";
import { round } from "../../../utils/tools";

const styles = {
  document: {
    color: "#000000",
    fontFamily: "sans-serif",
    fontSize: "9pt",
  },
  logo: {
    marginBottom: "10pt",
    textAlign: "center",
  },
  title: {
    fontSize: "16pt",
    margin: "0 0 16pt",
    textAlign: "center",
  },
  table: {
    borderCollapse: "collapse",
    fontSize: "9pt",
    width: "100%",
  },
  columnHeader: {
    backgroundColor: "#afaeae",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "left",
    verticalAlign: "middle",
  },
  amountHeader: {
    backgroundColor: "#afaeae",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "right",
    verticalAlign: "middle",
  },
  cell: {
    border: "1px solid #D3D3D3",
    padding: "4pt",
    verticalAlign: "top",
  },
  amountCell: {
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  totalLabelCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "left",
    verticalAlign: "middle",
  },
  totalAmountCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "right",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },
  recap: {
    marginTop: "8pt",
    textAlign: "left",
  },
};

export default class ListeRedditionPDF extends Component {
  render() {
    const { utilisateur, dateButoir, lignesReddition } = this.props;

    const societe = utilisateur.utilisateur_societe;

    const chemin = `${Constants.mode}://${Constants.domain}:${Constants.port}/api/societe/display/${societe.societe_id}`;

    let width = 200;
    let height = 30;

    if (societe.societe_logo_width) width = societe.societe_logo_width;
    if (societe.societe_logo_height) height = societe.societe_logo_height;

    let totalSolde = 0;
    let totalHonoraires = 0;
    let totalTVA = 0;
    let total = 0;

    lignesReddition.forEach((ligne) => {
      let honorairesHT = round(ligne.montantFrais / 1.2, 2);
      let honorairesTVA = ligne.montantFrais - honorairesHT;

      totalSolde += ligne.solde;
      totalHonoraires += ligne.montantFrais;
      totalTVA += honorairesTVA;
      total += ligne.montantDu;
    });

    total = lignesReddition.reduce((a, b) => a + parseFloat(b.montantDu), 0);

    return (
      <div style={styles.document}>
        {/* LOGO */}
        <div style={styles.logo}>
          <img src={chemin} width={width} height={height} alt="" />
        </div>

        {/* TITRE DOCUMENT */}
        <div style={styles.title}>
          <strong>{`LISTE PRÉPARATOIRE DES VIREMENTS DU ${
            dateButoir
              ? dayjs(dateButoir, "DD/MM/YYYY").format("DD/MM/YYYY")
              : dayjs().format("DD/MM/YYYY")
          }`}</strong>
        </div>

        {/* LIGNES QUITTANCES */}
        <table style={styles.table}>
          <thead>
            <tr>
              <th width="36%" style={styles.columnHeader}>
                <strong>Propriétaire</strong>
              </th>
              <th width="16%" style={styles.amountHeader}>
                <strong>Solde comptable</strong>
              </th>
              <th width="16%" style={styles.amountHeader}>
                <strong>Honoraires</strong>
              </th>
              <th width="16%" style={styles.amountHeader}>
                <strong>TVA</strong>
              </th>
              <th width="16%" style={styles.amountHeader}>
                <strong>À verser</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            {lignesReddition
              .sort((a, b) => parseInt(a.proprietaire_code) - parseInt(b.proprietaire_code))
              .map((ligne, i) => {
                let ligneHonorairesHT = round(ligne.montantFrais / 1.2, 2);
                let ligneHonorairesTVA = ligne.montantFrais - ligneHonorairesHT;
                return (
                  <tr
                    key={i}
                    style={{ backgroundColor: i % 2 === 0 ? "#ffffff" : "#eeeeee" }}
                  >
                    <td width="36%" style={styles.cell}>
                      {`${ligne.proprietaire_code} ${ligne.proprietaire_nom} ${ligne.proprietaire_prenom}`}
                    </td>
                    <td width="16%" style={styles.amountCell}>
                      {parseFloat(ligne.solde).toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                    <td width="16%" style={styles.amountCell}>
                      {parseFloat(ligne.montantFrais).toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                    <td width="16%" style={styles.amountCell}>
                      {parseFloat(ligneHonorairesTVA).toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                    <td width="16%" style={styles.amountCell}>
                      {parseFloat(ligne.montantDu).toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                  </tr>
                );
              })}
          </tbody>
          <tfoot>
            <tr>
              <th width="36%" style={styles.totalLabelCell}>
                <strong>Totaux</strong>
              </th>
              <td width="16%" style={styles.totalAmountCell}>
                {parseFloat(totalSolde).toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "EUR",
                })}
              </td>
              <td width="16%" style={styles.totalAmountCell}>
                {parseFloat(totalHonoraires).toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "EUR",
                })}
              </td>
              <td width="16%" style={styles.totalAmountCell}>
                {parseFloat(totalTVA).toLocaleString("fr-FR", {
                  style: "currency",
                  currency: "EUR",
                })}
              </td>
              <td width="16%" style={styles.totalAmountCell}>
                <strong>
                  {parseFloat(total).toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  })}
                </strong>
              </td>
            </tr>
          </tfoot>
        </table>

        {/* RECAPITULATIF NOMBRE DE LIGNES */}
        <div style={styles.recap}>
          {`Cette liste récapitulative comporte ${lignesReddition.length} ligne${
            lignesReddition.length > 1 ? "s" : ""
          }.`}
        </div>
      </div>
    );
  }
}
